import { ErrorBoundary } from "@neonumy/neonumy-ui";
import useStore from "config/store";
import { Outlet } from "react-router-dom";
import { AppHeader } from "views/Base/components/AppHeader";

export default function PrivateRoute() {
  const userData = useStore(state => state.userData);

  return (
    <ErrorBoundary>
      {userData && (
        <>
          <AppHeader />
          <Outlet />
        </>
      )}
    </ErrorBoundary>
  );
}
